/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_MarathonInputs */

const en_ui_pace_est_marathon = /** @type {(inputs: Ui_Pace_Est_MarathonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marathon`)
};

const de_ui_pace_est_marathon = /** @type {(inputs: Ui_Pace_Est_MarathonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marathon`)
};

/**
* | output |
* | --- |
* | "Marathon" |
*
* @param {Ui_Pace_Est_MarathonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_marathon = /** @type {((inputs?: Ui_Pace_Est_MarathonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_MarathonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_marathon(inputs)
	return de_ui_pace_est_marathon(inputs)
});